import React from "react";
import { Route, Routes } from "react-router-dom";
import { GameScreens } from "./screens/GameScreens";
import { useSelector } from "./redux/store";
import { SignInScreen } from "./screens/SignInScreen";

export const Navigator = () => {
  const user = useSelector((state) => state.auth.user);

  if (!user) {
    return <SignInScreen />;
  }
  return (
    <Routes>
      <Route path={"*"} element={<GameScreens />} />
      <Route path={"game/*"} element={<GameScreens />} />
    </Routes>
  );
};
